import { useEffect, useRef } from "react";
import chatHub from "../services/ChatHub";
import { ORDER_CHANGE_EVENT } from "../services/orderRealtimeEvents";

export const useOrderRealtimeEvents = (onOrderChange) => {
  const callbackRef = useRef(onOrderChange);

  useEffect(() => {
    callbackRef.current = onOrderChange;
  }, [onOrderChange]);

  useEffect(
    () => chatHub.subscribe(ORDER_CHANGE_EVENT, (event) => callbackRef.current?.(event)),
    [],
  );
};
